<re-modal target="executiveSummaryModal" title="Executive Summary">
  <quill-view-html [content]="(selectExecutiveSummary$ | async) ?? ''"></quill-view-html>
</re-modal>
